import React, { FC } from "react";
import { RouteComponentProps } from "react-router";
import Header from "go-app/components/Header";
import CorrectionFullForm from "./components/CorrectionFullForm";

const OrganizationSettingsCorrectionPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className="content">
			<Header title={"Korekcja stanów"} />
			<div>
				<CorrectionFullForm />
			</div>
		</div>
	);
};

export default OrganizationSettingsCorrectionPage;
